import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { Users, Plus, Mail } from 'lucide-react';

const TeamManagement = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-2xl font-bold text-foreground-primary">Team Management</h1>
        <p className="text-sm text-foreground-secondary mt-1">Manage your team members and roles</p>
      </div>

      {/* Current Team */}
      <div className="glass-frosted rounded-2xl p-6 glow-subtle">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold text-foreground-primary">Team Members</h2>
          <button
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-smooth"
            style={{ background: '#F97316', color: '#0B0E13' }}
          >
            <Plus size={14} />
            Invite
          </button>
        </div>

        {/* Owner */}
        <div className="space-y-3">
          <div className="flex items-center justify-between p-4 rounded-xl bg-subtle">
            <div className="flex items-center gap-4">
              {user?.avatar ? (
                <img src={user.avatar} alt="" className="w-9 h-9 rounded-full object-cover" />
              ) : (
                <div className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold" style={{ background: 'rgba(249,115,22,0.15)', color: '#F97316' }}>
                  {(user?.name || 'U').charAt(0).toUpperCase()}
                </div>
              )}
              <div>
                <p className="text-sm font-medium text-foreground-primary">{user?.name} <span className="text-xs text-foreground-muted">(You)</span></p>
                <p className="text-xs text-foreground-muted">{user?.email}</p>
              </div>
            </div>
            <span className="text-[10px] px-2 py-1 rounded-full font-semibold" style={{ background: 'rgba(249,115,22,0.1)', color: '#F97316' }}>
              Owner
            </span>
          </div>
        </div>

        {/* Empty state for additional members */}
        <div className="flex flex-col items-center justify-center py-8 mt-4 space-y-3 border-t border-subtle">
          <Users size={28} className="text-foreground-muted" />
          <p className="text-sm text-foreground-muted">No other team members</p>
          <p className="text-xs text-foreground-muted">Invite team members to collaborate on your projects.</p>
        </div>
      </div>

      {/* Pending Invitations */}
      <div className="glass-frosted rounded-2xl p-6 glow-subtle">
        <h2 className="text-lg font-semibold text-foreground-primary mb-4">Pending Invitations</h2>
        <div className="flex flex-col items-center justify-center py-8 space-y-3">
          <Mail size={28} className="text-foreground-muted" />
          <p className="text-sm text-foreground-muted">No pending invitations</p>
        </div>
      </div>
    </div>
  );
};

export default TeamManagement;
